import { isNotNullOrUndefined } from '@vy/utils';
import { getMonthIntervalLabel } from '../../modify-panel-shared/selectors/month-interval-labels';

/** A meter reset / refill interval option. `null` value = "None" (unset). */
export type MeterIntervalOption = { value: number | null; label: string };

export const NONE_METER_INTERVAL: MeterIntervalOption = { value: null, label: 'None' };

const METER_INTERVAL_MONTHS = [1, 2, 3, 6, 12];

/** Shared month-interval options for the Meter Reset / Meter Refill selects. */
export const METER_INTERVAL_OPTIONS: MeterIntervalOption[] = [
  NONE_METER_INTERVAL,
  ...METER_INTERVAL_MONTHS.map((months) => ({ value: months, label: getMonthIntervalLabel(months) })),
];

export const getMeterIntervalLabel = (option: MeterIntervalOption): string => option.label;

export function findMeterIntervalOption(value: number | undefined): MeterIntervalOption {
  return isNotNullOrUndefined(value)
    ? (METER_INTERVAL_OPTIONS.find((option) => option.value === value) ?? NONE_METER_INTERVAL)
    : NONE_METER_INTERVAL;
}
